// Google Maps orientation (rotation / tilt) support.
//
// Google's RASTER maps are effectively locked north-up. FREE rotation needs a
// VECTOR map, which needs a Map ID (Google Cloud Console → Maps → Create Map ID
// → JavaScript → Vector, Tilt + Rotation enabled). Put it in .env.local as
// REACT_APP_MAPS_ID and the Welcome Day map unlocks rotation automatically.
// Without it, we still enable the raster rotate control so nothing regresses.
export const GMAP_ID =
  process.env.REACT_APP_MAPS_ID || process.env.REACT_APP_MAPS_MAP_ID || undefined;
export const HAS_VECTOR_MAP = Boolean(GMAP_ID);

/** Map options that unlock orientation. Spread into `new google.maps.Map({...})`. */
export function orientationOptions() {
  return GMAP_ID
    ? { mapId: GMAP_ID, rotateControl: true, headingInteractionEnabled: true, tiltInteractionEnabled: true }
    : { rotateControl: true };
}
